import {
    getCabinetUser,
    getDeliveryRegions,
    deliverySave,
    getAllDeliveryUserProducts,
    getAllDelivery,
    messageReset
} from "./store/delivery";
import {useEffect, useState} from "react";
import {connect} from "react-redux";
import {toast} from "react-toastify";
import {Helmet} from "react-helmet";
import {
    Box,
    Typography,
    Button,
    MenuItem,
    Select,
    Paper,
    Grid,
    CircularProgress
} from "@mui/material";
import {useTelegram} from "./blocks/useTelegram";
import "./App.css"

function Delivery(props) {
    const {tg, userTg, onClose} = useTelegram();
    const [delivery_user_products, setDeliveryUserProducts] = useState([]);
    const [delivery_regions, setDeliveryRegions] = useState([]);
    const [delivery_products, setDeliveryProducts] = useState([]);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [regionId, setRegionId] = useState("");

    const getRegionName = (regionId) => {
        const region = props?.delivery_regions.find(r => r.id === regionId);
        return region ? region.title_uz : 'Noma\'lum';
    };

    useEffect(() => {
        const userId = userTg?.id || "11";
        props.getCabinetUser(userId);
    }, [userTg]);

    useEffect(() => {
        if (props.user) {
            setUser(props.user);
            props.getAllDeliveryUserProducts(props.user.id);
            props.getAllDelivery(-1);
            props.getDeliveryRegions();
            setLoading(false); // user yuklandi — spinner o'chadi
        } else if (props.user === null || props.user === undefined) {
            setLoading(false);
        }
    }, [props.user]);

    useEffect(() => {
        setDeliveryRegions(props.delivery_regions);
    }, [props.delivery_regions]);

    useEffect(() => {
        setDeliveryUserProducts(props.delivery_user_products)
    }, [props.delivery_user_products]);

    useEffect(() => {
        setDeliveryProducts(props.delivery_products);
    }, [props.delivery_products]);

    const handleRegionChange = (event) => {
        const selectedRegion = event.target.value;
        setRegionId(selectedRegion);
        if (selectedRegion) {
            props.getAllDelivery(selectedRegion);
        } else {
            props.getAllDelivery(-1);
        }
    };

    const handleAcceptDelivery = (product) => {
        if (!user?.id) return;
        const updatedProduct = {
            id: product.id,
            deliver: user.id,
        };
        props.deliverySave(updatedProduct);
    };

    const handleDeleteDelivery = (product) => {
        const updatedProduct = {
            id: product.id,
            deliver: null, // o'chirish uchun null
        };
        props.deliverySave(updatedProduct);
    };

    useEffect(() => {
        if (props.message === 'deleted' || props.message === true) {
            props.getAllDelivery(regionId || -1);
            if (user?.id) {
                props.getAllDeliveryUserProducts(user.id);
            }
        } else if (props.message === 'error') {
            toast.error("Xatolik yuz berdi", {theme: 'colored'});
        }
        props.messageReset();
    }, [props.message]);

    if (!loading && !user) {
        return (
            <Box p={4} textAlign="center">
                <Typography variant="h6" color="error">Foydalanuvchi topilmadi</Typography>
            </Box>
        );
    }

    if (!user) {
        return (
            <Box display="flex" justifyContent="center" mt={4}>
                <CircularProgress/>
            </Box>
        );
    }

    return (
        <Box p={2} maxWidth="600px" mx="auto">
            {/* Region tanlash */}
            <Box mb={4}>
                <Typography variant="subtitle1" gutterBottom fontWeight={600}>
                    Regionni tanlang:
                </Typography>
                <Select
                    fullWidth
                    value={regionId}
                    onChange={handleRegionChange}
                    displayEmpty
                    sx={{
                        backgroundColor: '#fff',
                        borderRadius: 2,
                        boxShadow: 1,
                    }}
                >
                    <MenuItem value=""><em>Tanlang</em></MenuItem>
                    {delivery_regions.map(region => (
                        <MenuItem key={region.id} value={region.id}>{region.title_uz}</MenuItem>
                    ))}
                </Select>
            </Box>

            {/* Yetkazilishi mumkin bo‘lgan buyurtmalar */}
            {delivery_products.length > 0 ? (
                <Grid container spacing={2}>
                    {delivery_products.map(product => (
                        <Grid item xs={12} key={product.id}>
                            <Paper
                                elevation={3}
                                sx={{
                                    p: 2,
                                    borderLeft: '5px solid #1976d2',
                                    transition: '0.2s',
                                    '&:hover': {
                                        boxShadow: 6,
                                        transform: 'scale(1.01)',
                                    },
                                }}
                            >
                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                    <Typography>
                                        {product.order} - {product.serial_number} ({getRegionName(product.region)}) ({+parseFloat(product.weight).toFixed(1)} kg, {product.pay_type === 'cash' ? 'Naqd' : 'Karta orqali'}): {product.fullname}
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        size="small"
                                        onClick={() => handleAcceptDelivery(product)}
                                        sx={{ml: 2}}
                                    >
                                        Qabul qilish
                                    </Button>
                                </Box>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>
            ) : (
                <Box mt={3} textAlign="center">
                    <Typography color="textSecondary" variant="body1">
                        Yetkazib berish uchun buyurtmalar yo‘q!
                    </Typography>
                </Box>
            )}

            {/* Mening buyurtmalarim */}
            <Box mt={6}>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                    Mening buyurtmalarim
                </Typography>
                {delivery_user_products.length === 0 ? (
                    <Typography color="text.secondary" textAlign="center">
                        Siz hali hech qanday buyurtma olmadingiz.
                    </Typography>
                ) : (
                    <Grid container spacing={2}>
                        {delivery_user_products.map(item => (
                            <Grid item xs={12} key={item.id}>
                                <Paper
                                    elevation={2}
                                    sx={{
                                        p: 2,
                                        borderLeft: '4px solid #2e7d32',
                                        backgroundColor: '#f9f9f9',
                                    }}
                                >
                                    <Box display="flex" justifyContent="space-between" alignItems="center">
                                        <Typography>
                                            {item.order} - {item.serial_number} ({getRegionName(item.region)}) ({parseFloat(item.weight).toFixed(1)} kg, {item.pay_type === 'cash' ? 'Naqd' : 'Karta orqali'}): {item.fullname}
                                        </Typography>
                                        <Button
                                            variant="outlined"
                                            color="error"
                                            size="small"
                                            onClick={() => handleDeleteDelivery(item)}
                                        >
                                            O‘chirish
                                        </Button>
                                    </Box>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                )}
            </Box>
        </Box>
    )
        ;
}

export default connect(
    props => props.delivery,
    {
        getCabinetUser,
        getDeliveryRegions,
        deliverySave,
        getAllDeliveryUserProducts,
        getAllDelivery,
        messageReset
    }
)(Delivery);